export const destinationIcons = Object.freeze({
  pathways: 'route',
  creators: 'guides',
  mentors: 'guides',
  'for-mentors': 'guides',
  institutions: 'school',
  collections: 'collections',
  programs: 'programs',
  resources: 'resources',
  journey: 'profile',
  overview: 'info',
  calendar: 'deadline',
  gallery: 'gallery',
  duration: 'duration',
  howto: 'howto',
  search: 'search',
  about: 'info',
  blog: 'blog',
  contact: 'contact',
  company: 'school',
  support: 'help'
})

const aliases = { paths: 'pathways', mentors: 'creators', schools: 'institutions', tools: 'resources' }

export function destinationIcon(kind, to) {
  const key = aliases[kind] || kind
  if (destinationIcons[key]) return destinationIcons[key]
  const path = typeof to === 'string' ? to : (to && to.path) || ''
  const route = path.split(/[/?#]/).find(part => ['pathways', 'for-mentors', 'mentors', 'creators', 'institutions', 'collections', 'programs', 'about', 'blogs', 'contact'].includes(part))
  return destinationIcons[route === 'blogs' ? 'blog' : route] || ''
}
